const state = {
  date: null,
  positionDate: []
};

const getters = {
  getDate: (state) => {
    return state.date
  },
  getPositionDate: (state) => {
    return state.positionDate
  },
};

const mutations = {
  setDate: (state, payload) => {
    state.date = payload
  },
  setPositionDate: (state, payload) => {
    state.positionDate = payload
  },
};

const actions = {
  actionSetDate({commit}, payload) {
    commit("setDate", payload);
  },
  actionSetPositionDate({commit}, payload) {
    commit("setPositionDate", payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
